define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            dateElementSelector: null, // set as a selector if there are multiple elements with date in the module container
            utcStartTime: null,
            utcEndTime: null,
            currentLanguage: null,
            nativeFormat: null // if set, this will be used to display the date(s), set this to the native JS format option object: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
        },

        init: function () {
            var self = this;

            let lang = self.options.currentLanguage ?? document.documentElement.lang;

            var elements = [];
            if (self.options.dateElementSelector != null) {
                elements = self.el.querySelectorAll('[data-timezoneconverter]');
            } else if (self.options.utcStartTime != null) {
                elements.push(self.el);
            }

            for (var i = 0; i < elements.length; i++) {
                var element = elements[i];

                // load these from the element itself instead of the module so each individual item can have a different date when dateElementSelector is used
                var elementSettings = Moduler.utils.parseSettings(element.getAttribute('data-timezoneconverter'));

                var startTime = self.getDateFromString(elementSettings.utcStartTime);

                var endTime = self.options.utcEndTime ? self.getDateFromString(elementSettings.utcEndTime) : null;

                let time = '';

                if (self.options.nativeFormat != null) {
                    time = startTime.toLocaleString(lang, self.options.nativeFormat);
                    if (endTime != null) {
                        time += '-' + endTime.toLocaleString(lang, self.options.nativeFormat);
                    }
                } else {
                    // the getXXX uses the local timezone
                    let isSameDate = endTime == null ||
                        (startTime.getFullYear() === endTime.getFullYear() &&
                            startTime.getMonth() === endTime.getMonth() &&
                            startTime.getDate() === endTime.getDate());

                    const fullDateFormat = { month: 'long', day: 'numeric', year: 'numeric' };
                    if (endTime == null || isSameDate) {
                        time = startTime.toLocaleString(lang, fullDateFormat);
                    } else {
                        // if start and end is the same month, use the special same month format
                        let isSameMonth = startTime.getMonth() === endTime.getMonth() && startTime.getFullYear() === endTime.getFullYear();
                        if (isSameMonth && self.shouldFormatSameMonth(lang)) {
                            time = self.formatSameMonthDate(startTime, endTime, lang);
                        } else {
                            let isSameYear = self.shouldFormatSameYear(lang) && startTime.getFullYear() === endTime.getFullYear();
                            time = startTime.toLocaleString(lang, isSameYear ? { month: 'long', day: 'numeric' } : fullDateFormat);
                            let sep = self.formatSeparator(' - ', lang);
                            time += sep;
                            time += endTime.toLocaleString(lang, fullDateFormat);
                        }
                    }
                }

                element.innerHTML = time;
            }
        },

        shouldFormatSameYear: function (lang) {
            if (lang.indexOf('ja') == 0) {
                return false;
            }
            return true;
        },

        shouldFormatSameMonth: function (lang) {
            if (lang.indexOf('ja') == 0) {
                return false;
            }
            return true;
        },

        formatSeparator: function(sep, lang) {
            if (lang.indexOf('es') == 0) {
                sep = ' al ';
            }
            return sep;
        },

        startDateFormat: function (lang) {
            if (lang.indexOf('zh') == 0) {
                return { month: 'long', day: 'numeric', year: 'numeric' };
            }
            return { month: 'long', day: 'numeric' };
        },

        endDateFormat: function (lang) {
            if (lang.indexOf('zh') == 0) {
                return { day: 'numeric' };
            }
            return { month: 'long', day: 'numeric', year: 'numeric' };
        },

        formatSameMonthDate: function (start, end, lang) {
            var self = this;
            let month = start.toLocaleString(lang, { month: 'long', day: 'numeric' })
                             .replace(start.toLocaleString(lang, { day: 'numeric' }), '')
                             .trim();
            let sep = self.formatSeparator('-', lang);
            const startDate = start.toLocaleString(lang, self.startDateFormat(lang));
            const endDate = end.toLocaleString(lang, self.endDateFormat(lang));

            let fullDate;

            //if startdate starts with the month, the best format is 'month day1-day2'', otherwise 'day1-day2 month' is better
            if (startDate.indexOf(month) > 0 && lang.indexOf('zh') == -1) {
                fullDate = startDate.replace(month, '').trim() + sep + endDate;
            } else {
                fullDate = startDate + sep + endDate.replace(month, '').trim();
            }

            return fullDate;
        },

        getDateFromString: function (dateString) {
            //iso8601 says a date can be "yyyy-mm-ddThh:mm:ssz", so replace space with T
            return new Date(dateString.replace(/[ ]/g, "T"));
        }
    });
});